import { useContext } from 'react'

import { ThemeContext } from './ThemeContext'

export function useThemeConfig () {
  const ctx = useContext(ThemeContext)
  if (!ctx) {
    throw new Error('Missing ThemeContext.Provider')
  }
  return ctx
}
